module.exports = __webpack_public_path__ + "img/btn_colorectal_off.46692f60.svg";